import { CheckCircle2 } from "lucide-react";

export const FormSuccess = ({ title, message, onReset, resetLabel = "Submit another response" }) => (
  <div
    className="rounded-2xl border border-success/30 bg-success/5 p-8 text-center"
    data-testid="form-success"
  >
    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-success/15">
      <CheckCircle2 className="h-8 w-8 text-success" />
    </div>
    <h3 className="mt-5 font-serif text-2xl text-navy">{title}</h3>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-muted-foreground">{message}</p>
    {onReset && (
      <button
        type="button"
        onClick={onReset}
        className="mt-6 rounded-lg border border-navy/20 px-5 py-2.5 text-sm font-semibold text-navy transition-colors hover:border-navy"
        data-testid="form-reset"
      >
        {resetLabel}
      </button>
    )}
  </div>
);

export const Field = ({ label, required, error, children }) => (
  <div>
    <label className="mb-1.5 block text-sm font-semibold text-charcoal">
      {label} {required && <span className="text-gold">*</span>}
    </label>
    {children}
    {error && <p className="mt-1 text-xs font-medium text-destructive">{error}</p>}
  </div>
);

export const inputCls =
  "w-full rounded-lg border border-border bg-white px-4 py-2.5 text-sm text-charcoal transition-all focus:border-navy focus:outline-none focus:ring-2 focus:ring-navy/15";

export const GdprConsent = ({ checked, onChange, error }) => (
  <div>
    <label className="flex cursor-pointer items-start gap-3 text-sm text-muted-foreground">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 shrink-0 rounded border-border accent-navy"
        data-testid="gdpr-consent"
      />
      <span>
        I consent to {`Azimi & Co. Vision Recruitment`} storing and processing my personal data in
        accordance with the Privacy Policy and GDPR Privacy Notice for the purpose of this enquiry.
      </span>
    </label>
    {error && <p className="mt-1 text-xs font-medium text-destructive">{error}</p>}
  </div>
);
